
import { defineComponent, onMounted, ref } from 'vue'
import copy from 'copy-to-clipboard'
import Share from 'tencent-share'
import { getUserInfo, login } from 'gh-qqnews-user'
import showApp from '@tencent/qqnews-show-appinfo'
import { getUrlKey, sleep, escape } from '@/core/utils'
import request from '@/core/request'
import { showTip } from '@/core/jsapi'
import Download from '@/core/download'
import { qqnews } from '@/core/config/appinfo'
import { actId } from '../../config'
import report from '../../utils/report'
import { shareSendInfo } from '../../config/share'
import { outMaterial, createShortUrl } from '../../api'
import OutBox from './Box.vue'
import OutHeader from './Header.vue'

export default defineComponent({
  name: 'OutSend',
  components: {
    OutBox,
    OutHeader
  },
  setup() {
    const item = ref({
      sender: '',
      call: '',
      receiver: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      receiver_type: '0',
      // eslint-disable-next-line @typescript-eslint/camelcase
      blessing_extend: '',
      id: ''
    })
    const sender = ref({
      // eslint-disable-next-line @typescript-eslint/camelcase
      head_url: '',
      nick: ''
    })
    const userInfo = ref({})
    const time = ref(0)
    const text = ref('')
    const loaded = ref(false)

    let _addparams: any = {}
    // eslint-disable-next-line no-underscore-dangle
    try {
      _addparams = JSON.parse(decodeURIComponent(getUrlKey('_addparams') || '""'))
    } catch (e) {
      console.error(`JSON.parse error`)
    }

    const createText = async () => {
      const { code, message, data } = await request(
        createShortUrl,
        { longUrl: window.location.href },
        { dataType: 'jsonp' }
      )
      if (code) {
        showTip(message)
      } else {
        loaded.value = true

        // eslint-disable-next-line @typescript-eslint/camelcase
        const { sender, call, receiver, blessing_extend, id } = item.value
        // eslint-disable-next-line @typescript-eslint/camelcase
        text.value = `${sender}为${call}${receiver}在腾讯新闻首页定制了一场跨年烟花秀，祝你${blessing_extend}!复制这段话$${id}$，或者点击链接：${data.shortUrl} 打开腾讯新闻app观看领红包`
      }
    }

    const loadMaterial = async (id: string) => {
      const { code, message, data } = await request(outMaterial(id))
      if (code) {
        showTip(message)
      } else {
        item.value = data.firework
        time.value = data.activity.redpack_countdown
        sender.value = data.sender
        new Share({
          ...shareSendInfo,
          title: `${data.sender.nick}在腾讯新闻头版定制了烟花红包，快来看吧~`,
          link: window.location.href
        })
        createText()
      }
    }

    const openApp = async () => {
      console.log(`openApp`)
      if (!loaded.value) {
        return
      }
      const download = new Download({
        ...qqnews,
        openUrl: `qqnews://article_9500?tab=news_news&from=2020firework_share_yanhua`,
        downloadUrl: 'http://dldir1.qq.com/dlomg/inews/TencentNews_13046.apk'
      })
      console.log(download)
      download.run()
      sleep(300).then(() => {
        console.log(text.value)
        copy(text.value)
      })
      report.send('sendWatchClick')
    }

    const openActivity = (type: string) => {
      console.log(`openActivity`)
      if (type === 'notice') {
        report.send('sendNoticClick')
      } else {
        report.send('sendCustomClick')
      }

      const download = new Download({
        ...qqnews,
        openUrl: `qqnews://article_9500?tab=news_news&from=2020firework_share_yanhua`,
        downloadUrl: 'http://dldir1.qq.com/dlomg/inews/TencentNews_13046.apk'
      })
      download.run(`${qqnews.openUrl}${actId}&_addLink=1&from=2020firework_share_yanhua`)
    }

    onMounted(() => {
      const { id } = _addparams
      if (id) {
        loadMaterial(escape(_addparams.id))
      }

      showApp(
        () => {
          const download = new Download({
            ...qqnews,
            openUrl: `qqnews://article_9500?tab=news_news&from=2020firework_share_yanhua`,
            downloadUrl: 'http://dldir1.qq.com/dlomg/inews/TencentNews_13046.apk'
          })
          download.run(`${qqnews.openUrl}${actId}&_addLink=1&from=2020firework_share_yanhua`)
        },
        '放烟花 领红包',
        '#fff'
      )
      report.send('sendPageExp')
    })

    return {
      time,
      item,
      text,
      userInfo,
      sender,
      openApp,
      openActivity
    }
  }
})
